var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"seasidetms_header_contacts_link",attrs:{"to":_vm.lang ? '/' + _vm.lang + '/contacts' : '/contacts'}},[_c('span',{staticClass:"seasidetms_header_contacts_link-icon seasidetms-icon-phone-alt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }